import { render } from "./CoverChart.vue?vue&type=template&id=1feac9cc"
import script from "./CoverChart.vue?vue&type=script&lang=js"
export * from "./CoverChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__